import cx from 'clsx';
import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Links } from '../../../components/links';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MButton } from '../../../@material-extend/Buttons/MButton';
import DrawerContent from './DrawerContent';
const drawerWidth = '100%';
const useStyles = makeStyles((theme) => createStyles({
    menuButton: { margin: 0, padding: 0 },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        display: 'flex',
        width: drawerWidth,
        color: '#333',
        '@media (min-width: 1159px)': { display: 'none' }
    },
    tryButton: {
        width: 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        background: '#4519ef !important',
        padding: '8px 40px',
        color: '#fff  !important',
        fontSize: '16px',
        marginLeft: 0,
        fontFamily: 'Poppins-SemiBold !important',
        borderRadius: ' 50px !important',
        marginRight: '16px',
        '&:hover': {
            color: '#fff',
            background: '#3E15D7',
            borderRadius: '50px !important',
            boxShadow: '0px 0px 2px 0px rgba(145, 158, 171, 0.24), 0px 12px 24px 0px rgba(145, 158, 171, 0.24)'
        }
    }
}));
const Sidebar = ({ queryPath, isCheckoutPage, currentLanguageLabel, onAction, Link, isLogin, intl, user, changeLang, additionalMenu, window, profile, proPlanId }) => {
    var _a, _b, _c, _d;
    const classes = useStyles();
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
    const container = window !== undefined ? () => window().document.body : undefined;
    return (React.createElement(Box, { sx: {
            gap: '15px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            '@media (min-width: 1159px)': { display: 'none' }
        } },
        React.createElement(CssBaseline, null),
        isLogin ? (React.createElement(React.Fragment, null, queryPath !== '/free-trial' &&
            ((_a = user === null || user === void 0 ? void 0 : user.trial) === null || _a === void 0 ? void 0 : _a.on_trial) === false &&
            ((_b = user === null || user === void 0 ? void 0 : user.subscription) === null || _b === void 0 ? void 0 : _b.sub_category) === 'free' &&
            currentLanguageLabel !== 'jp' ? (React.createElement(Links, { Link: Link, to: '/free-trial' },
            React.createElement(MButton, { className: cx(classes.tryButton), sx: { display: { xs: 'none', sm: 'flex' } } }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'try_for_free',
                defaultMessage: 'Try for free'
            })))) : !queryPath.includes('/user/checkout') &&
            ((_c = user === null || user === void 0 ? void 0 : user.trial) === null || _c === void 0 ? void 0 : _c.on_trial) === false &&
            ((_d = user === null || user === void 0 ? void 0 : user.subscription) === null || _d === void 0 ? void 0 : _d.sub_category) === 'basic' &&
            currentLanguageLabel !== 'jp' ? (React.createElement(Links, { Link: Link, to: '/user/checkout?q=' + proPlanId },
            React.createElement(MButton, { className: cx(classes.tryButton), sx: { display: { xs: 'none', sm: 'flex' } }, endIcon: React.createElement("img", { width: '18px', height: '18px', alt: 'Designs.ai Pro crown', src: 'https://assets.designs.ai/images/procrown.svg' }) }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'try_pro',
                defaultMessage: 'Try Pro'
            })))) : (''))) : (React.createElement(React.Fragment, null, queryPath !== '/free-trial' &&
            currentLanguageLabel !== 'jp' &&
            !queryPath.includes('/user/checkout') ? (React.createElement(Links, { Link: Link, to: '/free-trial' },
            React.createElement(MButton, { className: cx(classes.tryButton), sx: { display: { xs: 'none', sm: 'flex' } } }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'try_for_free',
                defaultMessage: 'Try for free'
            })))) : (''))),
        React.createElement(IconButton, { edge: 'start', "aria-label": 'open drawer', className: classes.menuButton, onClick: handleDrawerToggle },
            React.createElement("img", { alt: 'menu', src: 'https://assets.designs.ai/images/svg/icon-hamburger.svg' })),
        React.createElement(Hidden, { smUp: true, implementation: 'css' },
            React.createElement(Drawer, { container: container, variant: 'temporary', anchor: 'right', open: mobileOpen, onClose: handleDrawerToggle, classes: {
                    paper: classes.drawerPaper
                }, ModalProps: {
                    keepMounted: true // Better open performance on mobile.
                } },
                React.createElement(DrawerContent, { Link: Link, intl: intl, user: user, isLogin: isLogin, profile: profile, onAction: onAction, changeLang: changeLang, additionalMenu: additionalMenu, isCheckoutPage: isCheckoutPage, handleDrawerToggle: handleDrawerToggle, currentLanguageLabel: currentLanguageLabel })))));
};
export default Sidebar;
//# sourceMappingURL=Sidebar.js.map